import { ActionType, ProColumns, ProTable } from '@ant-design/pro-components';
import { Form } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import CustomProTable from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import { Filter } from 'base/ui/components/Icons';
import dayjs from 'dayjs';
import usePartialState from 'hooks/usePartialState';
import { cloneDeep } from 'lodash';
import { observer } from 'mobx-react';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox } from 'pages/Components/SearchBox';
import { SearchModel } from 'pages/model';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomerSurveyReportModel } from 'services/Main/reportVisitCustomerSR';
import { reportVisitCustomerSRPresenter, reportVisitCustomerSRStore, uiStore } from 'stores/root_store';
import { DATE_FORMAT_POST } from 'utils/constants';
import { formatNumber } from 'utils/formatHelper';
import FormSearchBox from './FormSearch';



// BÁO CÁO KHẢO SÁT Ý KIẾN KHÁCH HÀNG ====================================================
const createCustomerSurveyReport = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=================================================//
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const [dataReport, setDataReport] = useState<CustomerSurveyReportModel[]>([])
    const [dataTotal, setDataTotal] = useState<CustomerSurveyReportModel[]>([])

    //----------------------------------------- DATA TABLE ------------------------------------------
    const [dataSearch, setDataSearch] = useState<SearchModel>({
      companyCode: "1000",
    });


    const [loading, setLoading] = usePartialState({
      loadingSearch: false,
      loading: false,
    })


    // ---------------XỬ LÝ COLUMN VÀ TABLE-----------------------------------------------------------------------------------------------------
    const columns: ProColumns[] = [
      // stt
      {
        title: 'STT',
        dataIndex: 'stt',
        key: 'stt',
        width: 50,
        align: 'center',
      },
      // Trung tâm bảo hành
      {
        title: 'Trung tâm bảo hành',
        dataIndex: 'warrantyName',
        key: 'warrantyName',
        width: 150,
      },
      // Đánh giá chất lượng sản phẩm
      {
        title: 'Đánh giá chất lượng sản phẩm',
        children: [
          {
            title: `Tốt`,
            dataIndex: 'goodSP',
            key: 'goodSP',
            width: 100,
            align: 'right',
            render: (_, record) => {
              return (<>{formatNumber(record.goodSP, 0)}</>)
            }
          },
          {
            title: `Bình thường`,
            dataIndex: 'normalSP',
            key: 'normalSP',
            width: 100,
            align: 'right',
            render: (_, record) => {
              return (<>{formatNumber(record.normalSP, 0)}</>)
            }
          },
          {
            title: `Không tốt`,
            dataIndex: 'notGoodSP',
            key: 'notGoodSP',
            width: 100,
            align: 'right',
            render: (_, record) => {
              return (<>{formatNumber(record.notGoodSP, 0)}</>)
            }
          },
        ],
      },
      // Đánh giá chuyên môn/Nghiệp vụ của nhân viên
      {
        title: 'Đánh giá chuyên môn/Nghiệp vụ của nhân viên',
        children: [
          {
            title: `Tốt`,
            dataIndex: 'goodExpertise',
            key: 'goodExpertise',
            width: 100,
            align: 'right',
            render: (_, record) => {
              return (<>{formatNumber(record.goodExpertise, 0)}</>)
            }
          },
          {
            title: `Bình thường`,
            dataIndex: 'normalExpertise',
            key: 'normalExpertise',
            width: 100,
            align: 'right',
            render: (_, record) => {
              return (<>{formatNumber(record.normalExpertise, 0)}</>)
            }
          },
          {
            title: `Không tốt`,
            dataIndex: 'notGoodExpertise',
            key: 'notGoodExpertise',
            width: 100,
            align: 'right',
            render: (_, record) => {
              return (<>{formatNumber(record.notGoodExpertise, 0)}</>)
            }
          },
        ],
      },
      // Đánh giá hành vi/ Thái độ phục vụ của nhân viên
      {
        title: 'Đánh giá hành vi/ Thái độ phục vụ của nhân viên',
        children: [
          {
            title: `Tốt`,
            dataIndex: 'goodBehavior',
            key: 'goodBehavior',
            width: 100,
            align: 'right',
            render: (_, record) => {
              return (<>{formatNumber(record.goodBehavior, 0)}</>)
            }
          },
          {
            title: `Bình thường`,
            dataIndex: 'normalBehavior',
            key: 'normalBehavior',
            width: 100,
            align: 'right',
            render: (_, record) => {
              return (<>{formatNumber(record.normalExpertise, 0)}</>)
            }
          },
          {
            title: `Không tốt`,
            dataIndex: 'notGoodBehavior',
            key: 'notGoodBehavior',
            width: 100,
            align: 'right',
            render: (_, record) => {
              return (<>{formatNumber(record.notGoodBehavior, 0)}</>)
            }
          },
        ],
      },
      // Khách hàng không nghe nghe máy/ không liên lạc được
      {
        title: 'Khách hàng không nghe máy/ không liên lạc được',
        dataIndex: 'customerUnreachable',
        key: 'customerUnreachable',
        width: 150,
        align: 'right',
        render: (_, record) => {
          return (<>{formatNumber(record.customerUnreachable, 0)}</>)
        }
      },
      // Khách hàng không ý kiến/ không đánh giá
      {
        title: 'Khách hàng không ý kiến/ không đánh giá',
        dataIndex: 'customerNoFeedback',
        key: 'customerNoFeedback',
        width: 150,
        align: 'right',
        render: (_, record) => {
          return (<>{formatNumber(record.customerNoFeedback, 0)}</>)
        }
      },
      // Khách hàng không đánh giá
      {
        title: 'Khách hàng không đánh giá',
        dataIndex: 'notSurvey',
        key: 'notSurvey',
        width: 150,
        align: 'right',
        render: (_, record) => {
          return (<>{formatNumber(record.notSurvey, 0)}</>)
        }
      },
      // Ghi nhận ý kiến KH
      {
        title: 'Ghi nhận ý kiến KH',
        dataIndex: 'note',
        key: 'note',
        width: 100,
        align: 'right',
        render: (_, record) => {
          return (<>{formatNumber(record.note, 0)}</>)
        }
      },
    ];

    // ============================================ ===========================================================================
    const tableRef = useRef<ActionType>();

    const [open, setOpen] = usePartialState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });

    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };




    // lấy data báo cáo =============================================================================
    const getDataReport = async (dataSearch: object) => {

      const newTempt = Object.assign(dataSearch, {
        customerUnreachable: form.getFieldValue('customerUnreachable') ? "Có" : null,
        customerNoFeedback: form.getFieldValue('customerNoFeedback') ? "Có" : null
      })

      await reportVisitCustomerSRPresenter.getDataCustomerSurveyReport(reportVisitCustomerSRStore, newTempt);
      if (reportVisitCustomerSRStore.customerSurveyRP.isSuccess) {
        const dataTemp = cloneDeep(reportVisitCustomerSRStore.customerSurveyRP.data);

        // cắt phần tử "tổng" ra khỏi list data
        const listTotal = dataTemp.splice(dataTemp.length - 2, 2)
        setDataTotal(listTotal)
        setDataReport(dataTemp);
        return dataTemp;
      }
      setDataReport([]);
      return [];
    }




    return (
      <PageWrapper
        breadcrumb={[
          {
            text: 'BÁO CÁO KHẢO SÁT Ý KIẾN KHÁCH HÀNG',
          },
        ]}
        extras={
          <>
            {/* {checkPermission('CREATE') && (
              <div></div>
            )} */}
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <CustomProTable
            bordered
            columns={columns}
            dataSource={dataReport}
            // handleResize={() => { }}
            actionRef={tableRef}
            rowKey="stt"
            request={async (params = {}, sort, filter) => {
              let data: CustomerSurveyReportModel[] = []
              data = await getDataReport(dataSearch);
              return {
                data: data,
                success: reportVisitCustomerSRStore.customerSurveyRP.isSuccess,
              };
            }}
            scroll={{ x: 1000, y: 400 }}
            options={false}
            pagination={false}

            toolBarRender={() => [
              // EXPORT =================================================================
              <CustomButton
                loading={loading.loading}
                onClick={async () => {
                  setLoading({ loading: true });
                  const { paging, ...rest } = dataSearch
                  await reportVisitCustomerSRPresenter.exportExcelCustomerSurvey({ ...rest, lang: uiStore.language })
                  setLoading({ loading: false });
                }}
                icon={<Icon.Download className={'!fill-dark'} />}
              >
                {t('btn.export')}
              </CustomButton>]}

            summary={(data) => (
              <ProTable.Summary fixed>
                {
                  dataReport.length >= 1 && (
                    <>
                      {/* Sumary */}
                      <ProTable.Summary.Row className='[&_.ant-table-cell]:!text-textBlack' >
                        <ProTable.Summary.Cell align='center' className='font-bold' colSpan={2} index={0}>Tổng cộng</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={1}>{formatNumber(dataTotal.at(0)?.goodSP, 0)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={2}>{formatNumber(dataTotal.at(0)?.normalSP, 0)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={3}>{formatNumber(dataTotal.at(0)?.notGoodSP, 0)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={4}>{formatNumber(dataTotal.at(0)?.goodExpertise, 0)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={5}>{formatNumber(dataTotal.at(0)?.normalExpertise, 0)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={6}>{formatNumber(dataTotal.at(0)?.notGoodExpertise, 0)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={7}>{formatNumber(dataTotal.at(0)?.goodBehavior, 0)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={8}>{formatNumber(dataTotal.at(0)?.normalBehavior, 0)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={15}>{formatNumber(dataTotal.at(0)?.notGoodBehavior, 0)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={12}>{formatNumber(dataTotal.at(0)?.customerUnreachable, 0)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={13}>{formatNumber(dataTotal.at(0)?.customerNoFeedback, 0)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={9}>{formatNumber(dataTotal.at(0)?.notSurvey, 0)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={10}>{formatNumber(dataTotal.at(0)?.note, 0)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell index={11}></ProTable.Summary.Cell>
                      </ProTable.Summary.Row>
                      {/* TỶ LỆ */}
                      <ProTable.Summary.Row className='[&_.ant-table-cell]:!text-textBlack' >
                        <ProTable.Summary.Cell align='center' className='font-bold' colSpan={2} index={0}>Tỷ lệ(%)</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={1}>{formatNumber(dataTotal.at(1)?.goodSP, 2)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={2}>{formatNumber(dataTotal.at(1)?.normalSP, 2)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={3}>{formatNumber(dataTotal.at(1)?.notGoodSP, 2)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={4}>{formatNumber(dataTotal.at(1)?.goodExpertise, 2)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={5}>{formatNumber(dataTotal.at(1)?.normalExpertise, 2)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={6}>{formatNumber(dataTotal.at(1)?.notGoodExpertise, 2)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={7}>{formatNumber(dataTotal.at(1)?.goodBehavior, 2)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={8}>{formatNumber(dataTotal.at(1)?.normalBehavior, 2)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={15}>{formatNumber(dataTotal.at(1)?.notGoodBehavior, 2)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={12}>{formatNumber(dataTotal.at(1)?.customerUnreachable, 2)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={13}>{formatNumber(dataTotal.at(1)?.customerNoFeedback, 2)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={9}>{formatNumber(dataTotal.at(1)?.notSurvey, 2)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell align='right' className='font-bold' index={10}>{formatNumber(dataTotal.at(1)?.note, 2)}</ProTable.Summary.Cell>
                        <ProTable.Summary.Cell index={11}></ProTable.Summary.Cell>
                      </ProTable.Summary.Row>
                    </>
                  )
                }


              </ProTable.Summary>
            )}
          />

        </BoxContainer>

        {/* Form search */}
        <SearchBox
          onClose={onClose}
          className="lg:!w-[50%]"
          open={open.openDrawer}
          footer={
            <CustomButton
              htmlType="submit"
              className="my-auto ml-auto"
              loading={loading.loadingSearch}
              type="primary"
              onClick={() => {
                const value = form.getFieldsValue()
                // Lọc ra các key có giá trị không phải là chuỗi rỗng hoặc mảng rỗng
                const tempt = Object.fromEntries(
                  Object.entries(value).filter(([key, value]) => value !== "" && !(Array.isArray(value) && value.length === 0))
                ) as any;

                setDataSearch({
                  ...tempt,
                  endFromDate: tempt.endDate?.[0] ? dayjs(tempt.endDate?.[0])?.format(DATE_FORMAT_POST) : undefined,
                  endToDate: tempt.endDate?.[1] ? dayjs(tempt.endDate?.[1])?.format(DATE_FORMAT_POST) : undefined,
                  fromDate: tempt.ngayDanhGia?.[0] ? dayjs(tempt.ngayDanhGia?.[0])?.format(DATE_FORMAT_POST) : undefined,
                  toDate: tempt.ngayDanhGia?.[1] ? dayjs(tempt.ngayDanhGia?.[1])?.format(DATE_FORMAT_POST) : undefined,
                  paging: {
                    pageIndex: 1,
                    pageSize: 10
                  }
                });
                form.submit();
                tableRef.current?.reload();
                onClose();
              }}
            >
              {t('btn.search')}
            </CustomButton>
          }
        >
          <FormSearchBox dataSearch={dataSearch} form={form} tableRef={tableRef} loading={loading} setLoading={setLoading} setDataSearch={setDataSearch} />
        </SearchBox >
      </PageWrapper >
    )
  })

}

export default createCustomerSurveyReport